import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-wallet-svg-icon',
    templateUrl: 'duotone-wallet-svg-icon.component.html',
    standalone: false
})

export class DuotoneWalletSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
